import { CacheUtils } from '../utils/cacheUtils';

// время кэша 1 сутки
export const GET_REGIONS_API_CACHE_EXPIRES = 60 * 60 * 24;
export const GET_REGIONS_API_CACHE_KEY = 'getRegionsApi';

export const getRegionsApiCache = new CacheUtils(GET_REGIONS_API_CACHE_EXPIRES);
